// extracted by mini-css-extract-plugin
export default {"pageContainer":"OTPCode_pageContainer__6m6gq","title":"OTPCode_title__uy9uV","text":"OTPCode_text__xyFor"};